import React, { useEffect, useRef, useState } from "react";

import { motion, animate } from "motion/react";
import EmojiWave from "./emojiWave";
import { SongListHorizontal } from "../component/songList";
import { ActionButton, ActionButtonFull } from "../component/buttons";

import { Link } from "react-router";

export const CompatResult = ({ me, user, songs, songCount, next }) => {
  return (
    <div>
      <div className="compat-reaction">
        <div className="compat-reactions-avatars">
          <motion.div
            className="compat-avatar-container compat-avatar-container-left"
            initial={{ x: "-50%", y: "3%", rotate: 0, scale: 1 }}
            animate={{ x: "15%", y: "0%", rotate: -9, scale: 0.7 }}
            transition={{
              duration: 0.8,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            {user && user.image && (
              <img
                className="compat-avatar compat-avatar-left"
                src={user.image}
              />
            )}
          </motion.div>

          <motion.div
            className="compat-avatar-container compat-avatar-container-right"
            initial={{ x: "150%", rotate: 0, scale: 1 }}
            animate={{ x: "65%", y: "10%", rotate: 20, scale: 0.7 }}
            transition={{
              duration: 0.8,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            {me && me.image && (
              <img
                className="compat-avatar compat-avatar-right"
                src={me.image}
              />
            )}
          </motion.div>
        </div>

        <div className="compat-result-title-container">
          {user && user.name && (
            <h1 className="compat-title headline">{user.name} & you</h1>
          )}
          {songs && (
            <p className="compat-reaction-subtitle">
              {songCount} tracks in common
            </p>
          )}
        </div>

        <motion.div
          className="song-list-container"
          initial={{ scale: 1.2 }}
          animate={{ scale: 1.0 }}
          transition={{
            duration: 0.8,
            delay: 0.0,
            ease: [0, 0.71, 0.2, 1.01],
          }}
        >
          <SongListHorizontal songs={songs} />
        </motion.div>

        <div className="buttons">
          <button
            onClick={() => {
              next();
            }}
          >
            <ActionButton title="next" />
          </button>
        </div>
      </div>
    </div>
  );
};
